var checkout = {
    token: "",
    host: "",
    afiliate: "",
    ip: "",
    meeting: { status: false, ini: "", fin: "", date: "" },
    billing: {
      name: "",
      lastaname: "",
      email: "",
      phone: "",
      city: "",
      address: "",
      countryCode: "",
      documentNumber: "",
    },
    sendOrder: function (object) {
      checkout.order({
        publicationId: $(object).data("publicationid"),
        itemId: $(object).data("tipsid"),
        quantity: $(object).data("quantity"),
        upsellId: $(object).data("upsellid"),
        typeOrder: $(object).data("typeorder"),
        gateway: $(object).data("gateway"),
        upsellPublicationContentId: $(object).data("upsellpublicationcontentid"),
        upsellPaymentReference: $(object).data("upsellpaymentreference"),
        idBtn: $(object).attr("id"),
        params: { code: "" },
      });
    },
    test: function () {},
    order: function (object) {
      object.params = {
        ip: checkout.ip,
        upsellPublicationContentId: object.upsellPublicationContentId,
        upsellPaymentReference: object.upsellPaymentReference,
        code: object.params.code,
      };
      var idBtn = object.idBtn;
      var params = {
        publication: {
          id: object.publicationId,
        },
        items: [
          {
            id: object.itemId,
            name: "",
            quantity: object.quantity,
            amount: "",
            currency: "",
          },
        ],
        payment: {
          type: "CC",
          method: "",
          gateway: object.gateway,
          detail: {
            model: 0, //0pago, 1:suscripcion
            modality: 1,
          },
        },
        upsellId: object.upsellId,
        typeOrder: object.typeOrder,
        billing: checkout.billing,
        reference: "",
        currency: "",
        redirectUri: "",
        params: object.params,
      };
      var textBtnOrder = $("#" + idBtn).text();
      $("#" + idBtn).text("Procesando..");
      $("#" + idBtn).attr("disabled", true);
      $.ajax({
        url: checkout.host + "es/checkout/order",
        data: JSON.stringify(params),
        type: "POST",
        dataType: "json",
        headers: {
          Authorization: checkout.token,
          "Content-Type": "application/json",
        },
        success: function (data) {
          if (data.success == true) {
            console.log(data);
            Swal.fire({
              type: "success",
              title: "Ok...",
              text: "Su transacción se proceso correctamente",
            });
            $("#offertOneModal").modal("hide");
            $("#offertTwoModal").modal("hide");
            setInterval(function () {
              location.href = data.data.nextAction.redirectUri;
            }, 3000);
          } else {
            $("#" + idBtn).text(textBtnOrder);
            $("#" + idBtn).attr("disabled", false);
            Swal.fire({
              type: "error",
              title: "Oops...",
              text: data.message,
            });
          }
          $("#form-code-activation")
            .find(".btn-l-primary")
            .removeClass("btn-disable");
        },
        error: function (xhr, status) {
          Swal.fire({
            type: "error",
            title: "Oops...",
            text: "Se produjo un error, intentalo en unos minutos.",
          });
        },
      });
    },
    checkout: function (
      publicationId,
      itemId,
      type,
      quantity,
      priceId,
      recurring,
      month,
      editAmountRecurring,
      idText
    ) {
      /*if(auth.params.login == false) {
    $('#loginModal').modal('show');
    auth.functionContinue = 'checkout';
    auth.continue = true;
    auth.extraParams = {
    publicationId : publicationId,
    itemId : itemId,
    type : type,
    quantity : quantity,
    priceId : priceId,
    recurring : recurring,
    month : month
    };
    return false;
    }*/
      var amount = "";
      if (editAmountRecurring == 1) {
        var min = $("#" + idText).data("min");
        console.log(min);
        if ($("#" + idText).val() < min || isNaN($("#" + idText).val())) {
          Swal.fire({
            type: "error",
            title: "Oops...",
            text: "Monto debe ser mayor a " + min,
          });
          return false;
        }
        amount = $("#" + idText).val() * month;
      }
      var params = {
        product: {
          id: publicationId,
          type: type,
        },
        items: [
          {
            id: itemId,
            name: "",
            quantity: quantity,
            amount: amount,
            currency: "",
            priceId: priceId,
          },
        ],
        sesionDirect: true,
        billing: checkout.billing,
        reference: "",
        currency: "",
        afiliate: checkout.afiliate,
        redirectUri: "",
        recurring: {
          recurring: recurring,
          month: month,
        },
      };
      if (checkout.meeting.status) {
        params.product.meeting = checkout.meeting;
      }
  
      $.ajax({
        url: "/es/checkout/link",
        data: JSON.stringify(params),
        type: "POST",
        dataType: "json",
        headers: {
          Authorization: checkout.token,
          "Content-Type": "application/json",
        },
        success: function (data) {
          $("#form-login").find(".btn-l-primary").removeClass("block-btn-load");
          if (data.success == true) {
            location.href = data.data.url;
          } else {
            var messages = [];
            var i = 0;
            $.each(data.messages, function (index, value) {
              messages[i] = value;
              i++;
            });
            Swal.fire({
              type: "error",
              title: "Oops...",
              text: messages.join(", "),
            });
          }
        },
        error: function (xhr, status) {},
      });
    },
    checkoutRecurring: function (
      publicationId,
      itemId,
      type,
      recurringId,
      rDetailId
    ) {
      var amount = "";
      var params = {
        product: {
          id: publicationId,
          type: type,
        },
        items: [
          {
            id: itemId,
            name: "",
            quantity: 1,
            amount: amount,
            currency: "",
          },
        ],
        sesionDirect: true,
        billing: checkout.billing,
        reference: "",
        currency: "",
        afiliate: checkout.afiliate,
        redirectUri: "",
        recurring: {
          recurringId: recurringId,
          rDetailId: rDetailId,
          type: "repay",
        },
      };
  
      $.ajax({
        url: "/es/checkout/link",
        data: JSON.stringify(params),
        type: "POST",
        dataType: "json",
        headers: {
          Authorization: checkout.token,
          "Content-Type": "application/json",
        },
        success: function (data) {
          $("#form-login").find(".btn-l-primary").removeClass("block-btn-load");
          if (data.success == true) {
            location.href = data.data.url;
          } else {
            var messages = [];
            var i = 0;
            $.each(data.messages, function (index, value) {
              messages[i] = value;
              i++;
            });
            Swal.fire({
              type: "error",
              title: "Oops...",
              text: messages.join(", "),
            });
          }
        },
        error: function (xhr, status) {},
      });
    },
    addCart: function (publicationId, itemId, priceId) {
      var addTextHtml = `<i class="fas fa-shopping-cart"></i> AÑADIR`;
      var addLoaderHtml = `<i class="loader-btn"></i>`;
      $("#idIconAddCart" + itemId).empty();
      $("#idIconAddCart" + itemId).append(addLoaderHtml);
      //$("#idIconAddCart" + itemId).removeClass("fas fa-shopping-cart");
      //$("#idIconAddCart" + itemId).addClass("loader-btn");
      var params = {
        publicationId: publicationId,
        itemId: itemId,
        priceId: priceId
      };
      $.ajax({
        url: "/es/cart/add",
        data: params,
        type: "POST",
        dataType: "json",
        success: function (data) {
          if (data.success == true) {
            $("#idCartTotal").text(data.data.total);
            $("#id-quantity-header").text(data.data.quantity);
            $("#id-quantity-circle").text(data.data.quantity);
            console.log(priceId)
            if(typeof priceId ==='undefined') {
                var nameItemProd = "#idItemProduct" + itemId;
            } else {
                var nameItemProd = "#idItemProduct" + itemId + '_' + priceId;
            }
            console.log(nameItemProd);
            console.log($(nameItemProd))
            if ($(nameItemProd).length) {
              /*Si existe */
            } else {
              $("#idCartItem").append(data.data.html);
              custom.quantityNum();
              $(".btn-user-cart").dropdown("show");
            }
  
            $("#id-item-div-product-all").css("display", "block");
            $("#id-item-div-product-empty").css("display", "none");
          } else {
            Swal.fire({
              type: "error",
              title: "Oops...",
              text: data.messages,
            });
          }
          $("#idIconAddCart" + itemId).empty();
          $("#idIconAddCart" + itemId).append(addTextHtml);
          //$("#idIconAddCart" + itemId).removeClass("loader-btn");
          //$("#idIconAddCart" + itemId).addClass("fas fa-shopping-cart");
        },
        error: function (xhr, status) {},
      });
      return false;
    },
    updateCart: function (type, id, quantity) {
      $.ajax({
        url: "/es/cart/update",
        data: { type: type, id: id, params: quantity },
        type: "POST",
        dataType: "json",
        success: function (data) {
          if (data.success == true) {
            $("#idCartTotal").text(data.data.quantity);
            if (type == "remove") {
              $("#idItemProduct" + id).remove();
            }
            $("#id-quantity-header").text(data.data.quantity);
            $("#id-quantity-circle").text(data.data.quantity);
  
            $("#idCartTotal").text(data.data.total);
            if (data.data.quantity == 0) {
              $("#id-item-div-product-all").css("display", "none");
              $("#id-item-div-product-empty").css("display", "block");
            }
          } else {
          }
        },
        error: function (xhr, status) {},
      });
    },
    sendUrl: function () {
      $.ajax({
        url: "/es/cart/send",
        data: {},
        type: "POST",
        dataType: "json",
        success: function (data) {
          if (data.success == true) {
            location.href = data.url;
          } else {
            Swal.fire({
              type: "error",
              title: "Oops...",
              text: data.message,
            });
          }
        },
        error: function (xhr, status) {},
      });
    },
  };
  